import { render, staticRenderFns } from "./OpGiftPanel.vue?vue&type=template&id=344256c8&"
import script from "./OpGiftPanel.vue?vue&type=script&lang=ts&"
export * from "./OpGiftPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports